var _g, _g2, _g3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNoahBevel20(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 306 142.9",
    enableBackground: "new 0 0 306 142.9",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#BB3A07",
    points: "269,87.3 270.2,82.5 246.2,82.5 245.1,87.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#BB3A07",
    points: "283.3,140.2 284.4,135.4 260.5,135.4 259.4,140.2  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7F2602",
    d: "M286.1,135.4h-1.6l-1.1,4.8h-23.9l1.1-4.8h-1c-0.4,0-0.8-0.2-1-0.5c-0.2-0.3-0.3-0.7-0.3-1.1l-1.7,7.4 c-0.1,0.4,0,0.8,0.2,1.1c0.2,0.3,0.6,0.5,1,0.5h26.6c0.6,0,1.1-0.4,1.3-1L304.3,62c0,0,0,0,0,0l-16.9,72.5 C287.2,135,286.7,135.4,286.1,135.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7F2602",
    d: "M279.8,53L290,9c0,0,0,0,0,0L279.8,53L279.8,53z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7F2602",
    d: "M269,87.3h-23.9l1.1-4.8h-1c-0.4,0-0.8-0.2-1-0.5c-0.2-0.3-0.3-0.7-0.3-1.1l-1.7,7.4 c-0.1,0.4,0,0.8,0.2,1.1c0.2,0.3,0.6,0.5,1,0.5h25L269,87.3z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#BB3A07",
    points: "97.8,140.2 148.3,140.2 149.5,135.4 98.9,135.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#BB3A07",
    points: "134.2,87 135.3,82.2 111.4,82.2 110.2,87  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7F2602",
    d: "M169.4,61.9l-17,72.5c-0.1,0.6-0.7,1-1.3,1h-1.6l-1.1,4.8H97.8l1.1-4.8h-1c-0.4,0-0.8-0.2-1-0.5 c-0.2-0.3-0.3-0.7-0.3-1.1l-1.7,7.4c-0.1,0.4,0,0.8,0.2,1.1c0.2,0.3,0.6,0.5,1,0.5h53.3c0.6,0,1.1-0.4,1.3-1L169.4,61.9 C169.3,62,169.3,61.9,169.4,61.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7F2602",
    d: "M134.2,87h-23.9l1.1-4.8h-1c-0.4,0-0.8-0.2-1-0.5c-0.2-0.3-0.3-0.7-0.3-1.1l-1.7,7.4 c-0.1,0.4,0,0.8,0.2,1.1c0.2,0.3,0.6,0.5,1,0.5h25L134.2,87z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#BB3A07",
    points: "200.8,87 201.9,82.2 179.5,82.2 178.4,87  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#BB3A07",
    points: "235.4,140.2 236.5,135.4 167,135.4 165.9,140.2  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7F2602",
    d: "M225.6,106.2L236,62c0,0,0,0,0,0L225.6,106.2L225.6,106.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7F2602",
    d: "M238.1,135.4h-1.6l-1.1,4.8h-69.5l1.1-4.8h-1c-0.4,0-0.8-0.2-1-0.5c-0.2-0.3-0.3-0.7-0.3-1.1l-1.7,7.4 c-0.1,0.4,0,0.8,0.2,1.1c0.2,0.3,0.6,0.5,1,0.5h72.1c0.6,0,1.1-0.4,1.3-1l6.2-26.6c0,0,0,0,0,0l-4.5,19.2 C239.3,135,238.7,135.4,238.1,135.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7F2602",
    d: "M200.8,87h-22.4l1.1-4.8h-1c-0.4,0-0.8-0.2-1-0.5c-0.2-0.3-0.3-0.7-0.3-1.1l-1.7,7.4 c-0.1,0.4,0,0.8,0.2,1.1c0.2,0.3,0.6,0.5,1,0.5h23.5L200.8,87z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#BB3A07",
    points: "26.9,140.2 28,135.4 4.1,135.4 3,140.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#BB3A07",
    points: "67.1,82.2 43.2,82.2 42,87 66,87  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#BB3A07",
    points: "56.2,140.2 80.1,140.2 81.3,135.4 57.3,135.4  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7F2602",
    d: "M101.1,61.9l-17,72.5c-0.1,0.6-0.7,1-1.3,1h-1.6l-1.1,4.8H56.2l1.1-4.8h-1c-0.4,0-0.8-0.2-1-0.5 c-0.2-0.3-0.3-0.7-0.3-1.1l-1.7,7.4c-0.1,0.4,0,0.8,0.2,1.1c0.2,0.3,0.6,0.5,1,0.5h26.6c0.6,0,1.1-0.4,1.3-1L101.1,61.9 C101.1,62,101.1,62,101.1,61.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7F2602",
    d: "M66,87H42l-11.1,47.4c-0.1,0.6-0.7,1-1.3,1H28l-1.1,4.8H3l1.1-4.8H3c-0.4,0-0.8-0.2-1-0.5 c-0.2-0.3-0.3-0.7-0.3-1.1L0,141.3c-0.1,0.4,0,0.8,0.2,1.1c0.2,0.3,0.6,0.5,1,0.5h26.6c0.6,0,1.1-0.4,1.3-1l12.2-52.2h23.9L66,87z "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F95B1C",
    d: "M278.1,55.6c-0.4,0-0.8-0.2-1-0.5c-0.2-0.3-0.3-0.7-0.2-1.1l12-51.3h-23.9l-18.1,77.3h25 c0.4,0,0.8,0.2,1,0.5c0.2,0.3,0.3,0.7,0.2,1.1l-12,51.3H285l18.1-77.3H278.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFA60D",
    d: "M305.8,53.4c-0.2-0.3-0.6-0.5-1-0.5h-25h0L290,9l1.7-7.4c0.1-0.4,0-0.8-0.2-1.1s-0.6-0.5-1-0.5h-26.6 c-0.6,0-1.1,0.4-1.3,1l-18.7,79.9c0,0,0,0,0,0c-0.1,0.4,0,0.8,0.3,1.1c0.2,0.3,0.6,0.5,1,0.5h1h23.9l-1.1,4.8l-0.6,2.6l-10.3,43.9 c0,0,0,0,0,0c-0.1,0.4,0,0.8,0.3,1.1c0.2,0.3,0.6,0.5,1,0.5h1h23.9h1.6c0.6,0,1.1-0.4,1.3-1l16.9-72.5l1.7-7.4 C306.1,54.2,306,53.8,305.8,53.4z M285,132.8h-23.9l12-51.3c0.1-0.4,0-0.8-0.2-1.1c-0.2-0.3-0.6-0.5-1-0.5h-25l18.1-77.3h23.9 l-12,51.3c-0.1,0.4,0,0.8,0.2,1.1c0.2,0.3,0.6,0.5,1,0.5h25L285,132.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F95B1C",
    d: "M99.5,132.8h50.6l18.1-77.3h-50.6l-5.6,24h25c0.4,0,0.8,0.2,1,0.5c0.2,0.3,0.3,0.7,0.2,1.1l-6.2,26.6 c-0.1,0.6-0.7,1-1.3,1h-25.6L99.5,132.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFA60D",
    d: "M96.8,134.9c0.2,0.3,0.6,0.5,1,0.5h1h50.6h1.6c0.6,0,1.1-0.4,1.3-1l17-72.5l1.7-7.4c0.1-0.4,0-0.8-0.2-1.1 c-0.2-0.3-0.6-0.5-1-0.5h-53.3c-0.6,0-1.1,0.4-1.3,1l-6.2,26.6c0,0,0,0,0,0c-0.1,0.4,0,0.8,0.3,1.1c0.2,0.3,0.6,0.5,1,0.5h1h23.9 l-1.1,4.8l-0.6,2.6l-3.9,16.6h-25.6c-0.6,0-1.1,0.4-1.3,1l-6.2,26.6c0,0,0,0,0,0C96.5,134.3,96.6,134.6,96.8,134.9z M130.7,108.8 c0.6,0,1.1-0.4,1.3-1l6.2-26.6c0.1-0.4,0-0.8-0.2-1.1c-0.2-0.3-0.6-0.5-1-0.5h-25l5.6-24h50.6l-18.1,77.3H99.5l5.6-24H130.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F95B1C",
    d: "M224,108.8c-0.4,0-0.8-0.2-1-0.5c-0.2-0.3-0.3-0.7-0.2-1.1l12.1-51.6h-49.1l-5.6,24h23.5 c0.4,0,0.8,0.2,1,0.5c0.2,0.3,0.3,0.7,0.2,1.1l-6.2,26.6c-0.1,0.6-0.7,1-1.3,1h-24.1l-5.6,24h69.5l5.6-24H224z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFA60D",
    d: "M244.4,106.2h-18.7h0L236,61.9l1.7-7.4c0.1-0.4,0-0.8-0.2-1.1c-0.2-0.3-0.6-0.5-1-0.5h-51.7 c-0.6,0-1.1,0.4-1.3,1l-6.2,26.6c0,0,0,0,0,0c-0.1,0.4,0,0.8,0.3,1.1c0.2,0.3,0.6,0.5,1,0.5h1h22.4l-1.1,4.8l-0.6,2.6l-3.9,16.6 h-24.1c-0.6,0-1.1,0.4-1.3,1l-6.2,26.6c0,0,0,0,0,0c-0.1,0.4,0,0.8,0.3,1.1c0.2,0.3,0.6,0.5,1,0.5h1h69.5h1.6c0.6,0,1.1-0.4,1.3-1 l4.5-19.2l1.7-7.4c0.1-0.4,0-0.8-0.2-1.1C245.1,106.4,244.8,106.2,244.4,106.2z M237.1,132.8h-69.5l5.6-24h24.1 c0.6,0,1.1-0.4,1.3-1l6.2-26.6c0.1-0.4,0-0.8-0.2-1.1c-0.2-0.3-0.6-0.5-1-0.5h-23.5l5.6-24h49.1l-12.1,51.6 c-0.1,0.4,0,0.8,0.2,1.1c0.2,0.3,0.6,0.5,1,0.5h18.7L237.1,132.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F95B1C",
    d: "M69.8,80.1c0.2,0.3,0.3,0.7,0.2,1.1l-12.1,51.6h23.9l18.1-77.3H22.8L4.7,132.8h23.9l12.2-52.2 c0.1-0.6,0.7-1,1.3-1h26.6C69.1,79.6,69.5,79.8,69.8,80.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFA60D",
    d: "M55.3,134.9c0.2,0.3,0.6,0.5,1,0.5h1h23.9h1.6c0.6,0,1.1-0.4,1.3-1l17-72.5l1.7-7.4c0.1-0.4,0-0.8-0.2-1.1 c-0.2-0.3-0.6-0.5-1-0.5H21.7c-0.6,0-1.1,0.4-1.3,1L1.8,133.8c0,0,0,0,0,0c-0.1,0.4,0,0.8,0.3,1.1c0.2,0.3,0.6,0.5,1,0.5h1H28h1.6 c0.6,0,1.1-0.4,1.3-1L42,87l1.1-4.8h23.9L66,87l-0.6,2.6L55,133.8c0,0,0,0,0,0C54.9,134.2,55,134.6,55.3,134.9z M40.8,80.6 l-12.2,52.2H4.7l18.1-77.3h77.2l-18.1,77.3H57.9L70,81.2c0.1-0.4,0-0.8-0.2-1.1c-0.2-0.3-0.6-0.5-1-0.5H42.1 C41.5,79.6,41,80,40.8,80.6z"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "notes"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoahBevel20);
export default __webpack_public_path__ + "static/media/NoahBevel-20.2bcedfb6897bd60d33997dee2b44b3a8.svg";
export { ForwardRef as ReactComponent };